<template>
  <section class="appointment" ref="appointmentList">
    <div v-if="timeslotsLoading || timeslotsError">
      <Loader :loading="timeslotsLoading" :error="!!timeslotsError" />
    </div>
    <template v-else>
      <SmCrumbs
        class="appointment__crumbs"
        v-if="specialitiesSingleData['title']"
        :dynamic-name="{
          '/appointment': 'Запись к врачу',
          '/appointment/:specId': specialitiesSingleData['title']
        }"
      />
      <h2 class="appointment__title">
        Новая запись к врачу: {{ specialitiesSingleData['title'] }}
      </h2>
      <div class="limit-info" v-if="showLimit">
        <InfoIcon class="orange-info-icon" />
        <p>Чтобы записаться к врачу, пожалуйста, оформите договор.</p>
        <span class="green-text" @click="modalHandler">Подробнее</span>
      </div>
      <AppointmentFilter
        :initState="filters"
        @submit="submitFilters"
        @reset="resetFilter"
        @reset-all-filters="resetAllFilters"
      />
      <MainSorting @update="updateSorting" :initState="sorting" />
      <div
        v-if="doctorsInfo && doctorsInfo.length"
        class="doctor-cards-container"
      >
        <DoctorsCard
          v-for="record of doctorsInfo"
          :key="record.id + record.name"
          :doctorsData="record"
          :handleSlotClick="makeAnAppointment"
          :handleDoctorClick="openSingleDoctor"
        />
      </div>

      <div class="doctor-cards-empty" v-else>
        <h2>Нам не удалось найти подходящих врачей</h2>
        <span>Попробуйте изменить настроенные фильтры</span>
      </div>

      <Pagination
        :paginationInfo="this.paginationInfo"
        :getData="this.getList"
        :getMoreData="(payload) => this.getList({ ...payload, merge: true })"
        :autoLoad="false"
      >
      </Pagination>
      <ScheduleModal
        v-if="selectedDoctor"
        :patient="getAccountInfo.patientIds[0]"
        :selectedDoctor="selectedDoctor"
      />
      <ScheduleErrorModal v-if="selectedDoctor" />
      <RescheduleModal />
      <LimitModal />
    </template>
  </section>
</template>
<script>
import { vueSlideoutPanelService } from 'vue2-slideout-panel'
import { parseISO } from 'date-fns'
import { mapActions, mapGetters } from 'vuex'

import { TRACKER_SLUGS } from '@/models/tracker'
import { formatWithLocale, getWeekday, omitByNull } from '@/core/utils'

import InfoIcon from '@/assets/icons/info'

import ScheduleErrorModal from '@/components/modal/appointmentModals/scheduleErrorModal'
import RescheduleModal from '@/components/modal/appointmentModals/rescheduleModal'
import SmSlideMakeAnAppointment from '@/components/slideOutComponents/makeAnAppointment/makeAnAppointment'
import ScheduleModal from '@/components/modal/appointmentModals/scheduleModal'
import DoctorsCard from '@/components/doctorsCard'
import Pagination from '@/components/pagination/pagination'
import Loader from '@/components/loader'
import SmCrumbs from '@/components/breadcrumbs'
import LimitModal from '@/components/modal/admissionModals/limitModal'
import AppointmentFilter from '@/components/smFilters/AppointmentFilter'
import MainSorting from '@/components/mainSorting'

export default {
  name: 'AppointmentPage',
  components: {
    ScheduleModal,
    ScheduleErrorModal,
    LimitModal,
    SmCrumbs,
    RescheduleModal,
    Pagination,
    DoctorsCard,
    InfoIcon,
    Loader,
    AppointmentFilter,
    MainSorting
  },
  async created() {
    await this.getList({
      page: (Number(this.$route.query.page) || 1) - 1,
      size: Number(this.$route.query.size) || 5,
      doctorIds: this.$route.query.doctorId
        ? [this.$route.query.doctorId]
        : null,
      clinicIds: this.$route.query.clinicId
        ? [this.$route.query.clinicId]
        : null
    })
  },
  data() {
    return {
      showLimit: false,
      selectedDoctor: null,
      filters: {
        clinicIds: this.$route.query.clinicId
          ? [this.$route.query.clinicId]
          : null,
        doctorIds: this.$route.query.doctorId
          ? [this.$route.query.doctorId]
          : null,
        specialityId: null,
        doctorId: null,
        from: null,
        to: null,
        doctorSex: null,
        sort: 'APPOINTMENT_DATE',
        dates: null
      },
      sorting: [
        {
          id: 'APPOINTMENT_DATE',
          name: 'Ближайшая дата',
          selected: true
        }
        // {
        //   id: 'CLINIC',
        //   name: 'Клиника',
        //   selected: false
        // },
        // {
        //   id: 'DOCTOR',
        //   name: 'Назначивший врач',
        //   selected: false
        // },
        // {
        //   id: 'BIOMATERIAL',
        //   name: 'Вид',
        //   selected: false
        // }
      ]
    }
  },

  computed: {
    ...mapGetters('account', ['getAccountInfo']),
    ...mapGetters('appointment', ['errorCode']),
    ...mapGetters('timeslots', [
      'timeslotsData',
      'timeslotsLoading',
      'timeslotsError',
      'paginationInfo'
    ]),
    doctorsInfo: {
      get: function () {
        if (!this.timeslotsData.doctors.length) return []

        return this.timeslotsData.doctors.map((instance) => ({
          ...instance,
          priceInformation: {
            price:
              instance.clinics && instance.clinics.length
                ? instance.clinics[0].dates[0].price ?? 0
                : 0
          },
          specializationInfo: this.specialitiesSingleData,
          clinics: (instance.clinics || []).map(
            ({
              clinicName,
              address,
              id,
              'subway-stations': subway,
              dates = [],
              ...rest
            }) => ({
              ...rest,
              clinicName,
              address,
              subway: subway ? subway[0] : null,
              id,
              options: [
                ...dates.map(({ date, isAvailable }) => ({
                  label: formatWithLocale(
                    parseISO(date, 'yyyy-dd-MM'),
                    `dd MMMM, ${getWeekday(date)}`
                  ),
                  value: date,
                  isAvailable
                }))
              ].sort(
                (current, next) =>
                  new Date(current.value) - new Date(next.value)
              ),
              slots: dates
            })
          )
        }))
      },
      set: (v) => v
    },
    specialitiesSingleData() {
      return (
        this.timeslotsData.specialities[this.$route.params.specId] ?? {
          title: ''
        }
      )
    }
  },
  setup() {
    function submitFilters(payload) {
      switch (payload.id) {
        case 'doctorIds': {
          this.filters[payload.id] = payload.value
          this.$tracker(TRACKER_SLUGS.FILTER_APPOINTMENT_DOCTOR_NAME)
          break
        }
        case 'clinicIds': {
          this.filters[payload.id] = payload.value
          this.$tracker(TRACKER_SLUGS.FILTER_APPOINTMENT_CLINICS)
          break
        }
        case 'dates': {
          if (payload.value.calendarMode === 'range') {
            this.filters.from = `${payload.value.value.start}T10:26:52.398Z`
            this.filters.to = `${payload.value.value.end}T10:26:52.398Z`
            this.filters.dates = null
          }

          if (payload.value.calendarMode === 'mulitiple') {
            this.filters.from = null
            this.filters.to = null
            this.filters.dates = payload.value.value
          }

          this.$tracker(TRACKER_SLUGS.FILTER_APPOINTMENT_DATE)
          break
        }
        default:
          this.filters[payload.id] = payload.value
      }

      resetPage.apply(this)
      this.getList()
    }

    function updateSorting(name) {
      this.filters.sort = name

      resetPage.apply(this)
      this.getList()
    }

    function resetFilter(type) {
      switch (type) {
        case 'dates':
          this.filters.to = null
          this.filters.from = null
          this.filters.dates = null
          break
        default:
          this.filters[type] = null
      }

      resetPage.apply(this)
      this.getList()
    }

    function resetAllFilters() {
      for (const key in this.filters) {
        if (key === 'sort') continue
        this.filters[key] = null
      }

      resetPage.apply(this)
      this.getList()
    }

    function resetPage() {
      if (Number(this.$route.query.page) !== 0) {
        this.$router.push({ query: { page: '0' } })
      }
    }

    return {
      submitFilters,
      resetFilter,
      resetAllFilters,
      updateSorting
    }
  },
  methods: {
    ...mapActions('doctors', ['getDoctorById']),
    ...mapActions('appointment', [
      'createAppointment',
      'getSpecializationsById'
    ]),
    ...mapActions('qualifications', ['getQualifications']),
    ...mapActions('cities', ['getCities']),
    ...mapActions('timeslots', [
      'getTimeslots',
      'disableTimeslot',
      'getDoctorsFilter'
    ]),
    modalHandler() {
      this.$modals.show('limit-modal')
    },
    async openSingleDoctor({ id }) {
      await this.$router.push({
        path: `${this.$route.path}/${id}`
      })
    },
    async getList({ page, ...payload } = {}) {
      if (!payload.merge) {
        window.scrollTo({
          top: 0
        })
      }

      const filters = omitByNull(this.filters)

      await this.getTimeslots({
        ...(this.$route.params.specId
          ? { specialityIds: [this.$route.params.specId] }
          : {}),
        page: page ?? 0,
        size: Number(this.$route.query.size) || 5,
        groupByDoctor: true,
        ...filters,
        ...payload
      })
    },
    makeAnAppointment(info) {
      if (info.isScheduledAppointment) {
        this.$modals.show('reschedule-modal', {
          info
        })
      } else {
        this.$showPanel({
          component: 'SmSlideoutPanel',
          props: {
            title: 'Запись на приём',
            component: SmSlideMakeAnAppointment,
            properties: {
              ...info,
              makeAnAppointmentHandler: async (properties, comment) => {
                this.selectedDoctor = {
                  ...properties.selectedDoctor,
                  slot: properties.selectedSlot.slot,
                  specialityInfo: this.specialitiesSingleData
                }

                const payload = {
                  id: properties.getPatientInfo.accountId,
                  patientId: properties.getPatientInfo.id,
                  doctorId: properties.selectedDoctor.id,
                  specialityId: this.specialitiesSingleData.id,
                  clinicId: properties.selectedClinic?.id,
                  timeslotId: properties.selectedSlot?.slot?.id,
                  comment
                }

                const doctorId = properties.selectedDoctor.id
                const clinicId = properties.selectedClinic?.id
                const slotId = properties.selectedSlot?.slot?.id
                const dateTime = formatWithLocale(
                  parseISO(properties.selectedSlot?.slot.dateTime),
                  'yyyy-MM-dd'
                )

                try {
                  await this.createAppointment(payload)

                  if (this.errorCode) {
                    vueSlideoutPanelService.hideAllPanels()
                    this.disableTimeslot({
                      dateTime,
                      doctorId: properties.selectedDoctor.id,
                      clinicId: properties.selectedClinic?.id,
                      id: slotId
                    })
                    this.$modals.show('sm-schedule-error')
                    return false
                  }

                  this.disableTimeslot({
                    dateTime,
                    doctorId,
                    clinicId,
                    id: slotId
                  })
                } catch (e) {
                  vueSlideoutPanelService.hideAllPanels()
                  this.disableTimeslot({
                    dateTime,
                    doctorId: properties.selectedDoctor.id,
                    clinicId: properties.selectedClinic?.id,
                    id: slotId
                  })
                  this.$modals.show('sm-schedule-error')
                  return false
                }

                return true
              }
            }
          },
          openOn: 'right',
          width: '440',
          height: '80',
          sync: true,
          keepAlive: false
        }).promise.then(async (result) => {
          if (result?.closedBy) return
          if (result?.type === 'create') {
            await this.$router.push({
              name: 'UpcomingData',
              params: {
                clinic: result.selectedClinic,
                doctor: result.selectedDoctor,
                specializationTitle: this.specialitiesSingleData.title,
                dateTime: result.selectedSlot.slot.dateTime,
                address: result.selectedClinic.address,
                clinicName: result.selectedClinic.clinicName,
                patientFullName: `${result.getPatientInfo.name} ${result.getPatientInfo.surname}`,
                patientName: result.getPatientInfo.name,
                recommendation:
                  result.selectedDoctor.specializationInfo.recommendations
              }
            })
          }
          this.doctorsInfo = this.doctorsInfo.map((doctor) => {
            if (doctor.id === result) {
              doctor.isScheduledAppointment = true
              return doctor
            } else return doctor
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style.scss';
</style>
